import React from 'react';
import { Tooltip } from 'flowbite-react';
import { PiLink, PiLinkBreak } from 'react-icons/pi';

type AspectRatioLockButtonProps = {
  locked?: boolean;
  onToggle: () => void;
};

/**
 * Compact link/unlink control that sits between Width and Length in Metrics.
 * When locked, a stronger tint reinforces that the surrounding fields are linked.
 */
const AspectRatioLockButton: React.FC<AspectRatioLockButtonProps> = ({
  locked,
  onToggle,
}) => {
  const label = locked ? 'Unlock aspect ratio' : 'Lock aspect ratio';

  return (
    <div className="flex h-8 self-end items-center justify-center">
      <Tooltip content={label}>
        <button
          type="button"
          aria-label={label}
          aria-pressed={Boolean(locked)}
          className={`flex h-8 w-7 items-center justify-center rounded-sm transition-colors ${
            locked
              ? 'bg-gray-200 text-gray-900'
              : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
          }`}
          onClick={onToggle}
        >
          {locked ? <PiLink fontSize={16} /> : <PiLinkBreak fontSize={16} />}
        </button>
      </Tooltip>
    </div>
  );
};

export default AspectRatioLockButton;
